import script from "./footer2.vue?vue&type=script&setup=true&lang=js"
export * from "./footer2.vue?vue&type=script&setup=true&lang=js"

import "./footer2.vue?vue&type=style&index=0&id=0f353298&lang=scss&scoped=true"

import exportComponent from "/Users/canfengchen/eclipse-workspace/gsjy/dxzjapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f353298"]])

export default __exports__